import Lightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";
Lightbox({
	touchNavigation: true,
	loop: true
});